export default "__VITE_ASSET__BsHSm28l__"